import SortByControl from './SortByControl';

export { type SortByControlProps } from './SortByControl';
export default SortByControl;
